export default {
  state: {
    menuList: {},
    btnInfo: {}
  },
  getters: {
    menuList: state => state.menuList,
    btnInfo: state => state.btnInfo
  },
  mutations: {
    menuList (state, data) {
      state.menuList = data
    },
    btnInfo (state, data) {
      state.btnInfo = data
    }
  },
  actions: {
    handleMenuList (menuList, data) {
      menuList.commit('menuList', data)
    },
    handleBtnInfo (btnInfo, data) {
      btnInfo.commit('btnInfo', data)
    }
  }
}
